module.exports = __webpack_public_path__ + "img/GHS03.3abca323.webp";